export const ADMIN_PANEL_NAVIGATION_CONSTANTS = {
  NAVIGATION_HEADER_NAME: 'Admin Panel',
  ADD_USER_PAGE_LINK_NAME: 'Add User',
  LIST_USER_PAGE_LINK_NAME: 'List User',
};
